import apiClient from '@/lib/api';

export interface AdminPlan {
  id: number;
  name: string;
  displayName: string;
  priceMonthly: number;
  isActive: boolean;
}

export const plansService = {
  getPlans: async (): Promise<AdminPlan[]> => {
    const response = await apiClient.get<{ data: AdminPlan[] }>('/admin/plans');
    return response.data.data;
  }
};
